import React from "react";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";
import ViewPost from "./View";

const ViewIndex = () => {
    return (
        <MainLayout>
            <FeedLayout>
                <ViewPost />
            </FeedLayout>
        </MainLayout>
    );
};

export default ViewIndex;
